import React from 'react'

const Dashboard = React.lazy(() => import('./Dashboard'))

export const dashboardPresensiConfigs = [
    {
        path: '/presensi/dashboard',
        element: <Dashboard />
    },
]